<div class="position-relative">
  @if (modelSignal()) {
    <div
      [ngClass]="modalIconClass()"
      class="rounded-pill text-white top-0 start-50 position-absolute translate-middle modal-dialog-decoration"
    >
      <i class="fas fa-2x {{ modelSignal().iconTypeClass || 'fa-bell' }}" aria-hidden="true"></i>
    </div>
    <mwe-basic-card [id]="modelSignal().id" cardClass="modal-dialog-notch text-center pt-4">
      <!-- TODO add type for icon / color -->
      <h1 class="h4 mb-3" [translate]="modelSignal().titleKey" data-test="popup-title" id="mwe_popup-title"></h1>
      @if (modelSignal().messageKey | translate) {
        <p class="mb-4" [innerHTML]="modelSignal().messageKey | translate" data-test="popup-message"></p>
      }
      @if (modelSignal().formModel) {
        <div class="mb-4">
          <mwe-form (formSubmitted)="submit()" [formModel]="modelSignal().formModel" />
        </div>
      }
      <div class="row g-3">
        @if (modelSignal().showSubmitButton) {
          <mwe-button (clicked)="submit()" [labelKey]="modelSignal().submitButtonKey" buttonId="popup-submit-link" />
        }
        @if (modelSignal().showCancelButton) {
          <mwe-button
            (clicked)="cancel()"
            [labelKey]="modelSignal().cancelButtonKey"
            [route]="modelSignal().cancelButtonHref"
            [category]="modelSignal().showAdditionalButtons ? 'secondary' : 'tertiary'"
            buttonId="popup-cancel-link"
          />
        }
        @if (modelSignal().showAdditionalButtons) {
          @for (button of modelSignal().additionalButtons; track $index) {
            <mwe-button
              (clicked)="clickAdditionalButton(getAdditionalButtonId(button.buttonId, '' + $index))"
              [buttonId]="getAdditionalButtonId(button.buttonId, '' + $index)"
              [labelKey]="button.buttonKey"
              [url]="button.buttonHref"
              category="tertiary"
            />
          }
        }
      </div>

      <div #testAnchorElementFeedback></div>
    </mwe-basic-card>
  }
</div>
